module.exports = __webpack_public_path__ + "files/839433fa6e38a40882d909140e1a739a.png";